// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type ImageSearch20Props = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const ImageSearch20: FC<ImageSearch20Props> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="20"
            height="20"
            viewBox="0 0 20 20"
        >
            <path d="M16.833 10a.833.833 0 1 1 1.667 0v4.5A2.5 2.5 0 0 1 16 17H4a2.5 2.5 0 0 1-2.5-2.5v-9A2.5 2.5 0 0 1 4 3h7.666a.833.833 0 0 1 0 1.666H4a.833.833 0 0 0-.833.834v9c0 .46.373.833.833.833h12c.46 0 .833-.373.833-.833z" />
            <path d="M11.667 10A1.667 1.667 0 1 0 10 11.666v1.667a3.333 3.333 0 1 1 0-6.666 3.333 3.333 0 0 1 0 6.666v-1.667c.92 0 1.667-.746 1.667-1.666M13.808 5.158a.167.167 0 0 1 0-.316l.444-.148a3.33 3.33 0 0 0 2.108-2.109l.149-.444a.167.167 0 0 1 .316 0l.148.444a3.33 3.33 0 0 0 2.108 2.109l.445.148a.167.167 0 0 1 0 .316l-.445.148a3.33 3.33 0 0 0-2.108 2.108l-.148.445a.167.167 0 0 1-.316 0l-.149-.445a3.33 3.33 0 0 0-2.108-2.108z" />
        </svg>
    );
};

export default ImageSearch20;
